import { EMPTY_REQUEST_ROW } from '../Constants/strings';

export const validateRequestRow = (row = EMPTY_REQUEST_ROW) => {
  if (!row.projectId) return 'Please select project.';
  if (!row.vertical) return 'Please select vertical.';
  if (!row.experience) return 'Please select experience.';
  if (!row.resourceNo || Number(row.resourceNo) <= 0) return 'No of resource should be more than zero.';
  if (!Number.isInteger(Number(row.resourceNo))) return 'No of resource should be integer value.';
  if (!row.allocation || Number(row.allocation) <= 0) return 'Allocation % should be more than zero.';
  if (Number(row.allocation) > 100) return 'Allocation % should be less than or equal to 100.';
  if (!row.startDate) return 'Please enter start date.';
  if (!row.endDate) return 'Please enter end date.';
  if (row.startDate > row.endDate) return 'Start date cannot be greater than end date.';
  if (!row.roleId) return 'Please select role.';
  if (!row.mandatorySkills?.trim()) return 'Please enter mandatory skills.';
  return '';
};

export const validateProjectStatusForRequest = (projectStatus = '') => {
  const normalizedStatus = String(projectStatus || '')
    .trim()
    .toLowerCase();
  if (normalizedStatus === 'on hold' || normalizedStatus === 'closed') {
    return 'Staffing request cannot be raised for the "On Hold", Closed project.';
  }
  return '';
};

export const validateSubmitRows = (rows = []) => {
  if (!rows.length) return 'Add at least one request row before submit.';

  const rowError = rows
    .map((row, index) => ({ index, error: validateRequestRow(row) }))
    .find((item) => item.error);

  if (rowError) {
    return `Row ${rowError.index + 1}: ${rowError.error}`;
  }

  return '';
};
